import { Col, Row, Popover, Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import { emptyFn } from 'utils/common';
import Enums from 'utils/EnumsManager';
import Dropdown from './Dropdown';
import OrderBtn from './OrderBtn';
import styles from '../index.less';

const cx = classNames.bind(styles);

const { ascend, descend } = Enums.SortOrders;

const defaultProps = {
  onDropdownChange: emptyFn,
  onOrderClick: emptyFn,
  selectedValue: '',
  sortOrder: ascend
};
const propTypes = {
  onDropdownChange: PropTypes.func,
  onOrderClick: PropTypes.func,
  options: PropTypes.array.isRequired,
  selectedValue: PropTypes.string,
  sortOrder: PropTypes.oneOf([ascend, descend]),
  sortOnCurrentColumn: PropTypes.bool.isRequired
};

const ColumnHeader = ({
  onDropdownChange,
  onOrderClick,
  options,
  selectedValue,
  sortOrder,
  sortOnCurrentColumn
}) => {
  const hasRestrictedField = options.some(option => option.restriction);
  const hasDeletedField = options.some(option => option.deleted);
  const invalidSelected = selectedValue && options.every(option => selectedValue !== option.key);
  const renderErrorIcon = () => {
    let errorKey = '';
    switch (true) {
      case hasRestrictedField:
        errorKey = 'hasRestrictedField';
        break;
      case hasDeletedField:
        errorKey = 'hasDeletedValue';
        break;
      case invalidSelected:
        errorKey = 'invalidSelected';
        break;
      default:
        break;
    }

    return (
      <Popover content={<FormattedMessage id={`global.errors.${errorKey}`} />} trigger="hover">
        <Icon className={classNames(cx('restriction'), 'pl-sm')} type="warning" />
      </Popover>
    );
  };

  const isSelectedValueError = (hasRestrictedField && selectedValue !== 'count') || (hasDeletedField && selectedValue !== 'count') || invalidSelected ; 
  return (
    <Row gutter={8}>
      <Col sm={16}>
        <Dropdown
          data={options}
          onChange={onDropdownChange}
          value={selectedValue}
          selectedValueError={isSelectedValueError}
        />
      </Col>
      <Col sm={1}>
        <OrderBtn
          isActive={sortOnCurrentColumn}
          isAscending={sortOrder === ascend}
          onClick={isAscending => onOrderClick(isAscending ? descend : ascend)}
        />
      </Col>
      <Col sm={7}>
        {(hasRestrictedField || hasDeletedField || invalidSelected) &&
          renderErrorIcon()
        }
      </Col>
    </Row>
  );
};

ColumnHeader.defaultProps = defaultProps;
ColumnHeader.propTypes = propTypes;
export default ColumnHeader;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/Table/components/UIs/ColumnHeader.jsx